import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'EmailLink' })({
    root: {
        color: '#fff',
        fontSize: 18,
        fontWeight: 500,
        lineHeight: '27px',
        letterSpacing: '-0.36px',
        textDecoration: 'none',
        transition: 'opacity 0.2s',
        opacity: 1,
        '&:visited': {
            color: '#fff'
        },
        '&:hover': {
            opacity: 0.8
        }
    }
});
